import React, { useState, useEffect } from 'react';
import { FaBars, FaTachometerAlt, FaUser, FaOutdent, FaShippingFast, FaNewspaper, FaUsers, FaCog, FaFile, FaRegEnvelope } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { logout } from '../services/actions/LoginAction';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import Swal from 'sweetalert2';
import Loader from '../pages/components/Loader';
import Logo from '../assets/images/logo.png';
import { FaBagShopping } from "react-icons/fa6";

const Layout = ({ title, children }) => {
    const [isToggled, setIsToggled] = useState(false);
    const dispatch = useDispatch();
    const [activeIndex, setActiveIndex] = useState(1);
    const [activeMenu, setActiveMenu] = useState("dashboard");

    const user = useSelector((state) => state.LoginReducer.authData);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const storedIndex = localStorage.getItem('activeIndex');
        if (storedIndex) {
            setActiveIndex(Number(storedIndex));
        }
    }, []);

    const handleItemClick = (index) => {
        setActiveIndex(index);
        localStorage.setItem('activeIndex', index);
    };

    const handleMenuClick = (menu) => {
        setActiveMenu(menu);
    };

    const handleLogout = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const token = user.data.token;
            await dispatch(logout(token));
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: 'Logout failed. Please try again.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
    
        return () => clearTimeout(timer);
    }, []);

    const handleToggle = (e) => {
        e.preventDefault();
        setIsToggled(!isToggled);
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <div id="wrapper" className={isToggled ? 'toggled' : ''}>
            <aside id="sidebar-wrapper">
                <div className="sidebar-brand">
                    <img src={Logo} alt="logo" />
                    <ul className="sidebar-nav">
                        <li className={`item ${activeIndex === 1 ? 'active' : ''}`} onClick={() => handleItemClick(1)}>
                            <Link to={'/dashboard'}><FaTachometerAlt /> Dashboard</Link>
                        </li>
                        <li className={`item ${activeIndex === 2 ? 'active' : ''}`} onClick={() => handleItemClick(2)}>
                            <Link to={'/orders'}><FaBagShopping /> Orders</Link>
                        </li>
                        <li className={`item ${activeIndex === 3 ? 'active' : ''}`} onClick={() => handleItemClick(3)}>
                            <Link to={'/users'}><FaUser /> User Management</Link>
                        </li>
                        <li className={`item ${activeIndex === 4 ? 'active' : ''}`}>
                            <a href="#" className='dropdown-toggle' id="open-drop" data-bs-toggle="dropdown" aria-expanded="false">
                                <FaOutdent /> Products
                            </a>
                            <ul className='dropdown-menu' aria-labelledby="open-drop">
                                <li onClick={() => handleItemClick(4)}><Link to={'/categories'} className="dropdown-item">Categories</Link></li>
                                <li onClick={() => handleItemClick(4)}><Link to={'/products'} className="dropdown-item">Products</Link></li>
                            </ul>
                        </li>
                        <li className={`item ${activeIndex === 5 ? 'active' : ''}`} onClick={() => handleItemClick(5)}>
                            <Link to={'/coupons'}><FaNewspaper />Coupons</Link>
                        </li>
                        <li className={`item ${activeIndex === 6 ? 'active' : ''}`} onClick={() => handleItemClick(6)}>
                            <Link to={'/blogs'}><FaNewspaper />Blogs</Link>
                        </li>
                        <li className={`item ${activeIndex === 7 ? 'active' : ''}`} onClick={() => handleItemClick(7)}>
                            <Link to={'/testimonials'}><FaNewspaper />Testimonials</Link>
                        </li>
                        <li className={`item ${activeIndex === 8 ? 'active' : ''}`} onClick={() => handleItemClick(8)}>
                            <Link to={'/shippings'}><FaShippingFast /> Shipping</Link>
                        </li>
                        <li><a type="button" onClick={handleLogout}><FaCog /> Logout</a></li>
                    </ul>
                </div>
            </aside>
            <div id="navbar-wrapper">
                <nav className="navbar navbar-inverse">
                    <div className="container-fluid">
                        <div className="navbar-header">
                            <button onClick={handleToggle} className="navbar-brand">
                                <FaBars />
                            </button>
                            <h1 className="h2">{title}</h1>
                        </div>
                    </div>
                </nav>
            </div>
            <section id="content-wrapper">
                {children}
            </section>
        </div>
    );
};

export default Layout;
